(function (Drupal, once) {
  'use strict';

  /**
   * Behavior for expanding/collapsing review details
   */
  Drupal.behaviors.reviewsExpand = {
    attach: function (context) {
      const reviewCards = once('reviewsExpand', '.review-card', context);

      reviewCards.forEach(function (card) {
        const expandBtn = card.querySelector('.review-card__toggle--expand');
        const collapseBtn = card.querySelector('.review-card__toggle--close');

        if (!expandBtn || !collapseBtn) {
          return;
        }

        // Handle expand button click
        expandBtn.addEventListener('click', function (e) {
          e.preventDefault();
          card.classList.remove('is-collapsed');

          const announcement = document.createElement('div');
          announcement.setAttribute('role', 'status');
          announcement.setAttribute('aria-live', 'polite');
          announcement.className = 'visually-hidden';
          announcement.textContent = Drupal.t('Review details expanded');
          document.body.appendChild(announcement);

          setTimeout(function() {
            document.body.removeChild(announcement);
          }, 1000);
        });

        // Handle collapse button click
        collapseBtn.addEventListener('click', function (e) {
          e.preventDefault();
          card.classList.add('is-collapsed');

          // Scroll to the top of the card for better UX
          const cardTop = card.getBoundingClientRect().top + window.pageYOffset;
          const offset = 100;

          window.scrollTo({
            top: cardTop - offset,
            behavior: 'smooth'
          });

          const announcement = document.createElement('div');
          announcement.setAttribute('role', 'status');
          announcement.setAttribute('aria-live', 'polite');
          announcement.className = 'visually-hidden';
          announcement.textContent = Drupal.t('Review details collapsed');
          document.body.appendChild(announcement);

          setTimeout(function() {
            document.body.removeChild(announcement);
          }, 1000);
        });
      });
    }
  };

})(Drupal, once);
